import React from 'react';
import { PackageIcon, TruckIcon } from '@fronton/icons-react';
import { DeliveryMethodIcon } from 'common/icons';

type DeliveryOptionIconProps = {
  type: string;
} & React.HTMLAttributes<HTMLElement>;

export const DeliveryOptionIcon: React.FC<DeliveryOptionIconProps> = ({ type, color }) => {
  let result = null;
  switch (type) {
    case 'DELIVERY':
    case 'HOME_DELIVERY': {
      result = <TruckIcon type={'duotone'} size="l" color={color} />;
      break;
    }
    case 'PICKUP': {
      result = <DeliveryMethodIcon />;
      break;
    }
    case 'POINT':
    case 'PICKUP_POINT': {
      result = <PackageIcon type={'duotone'} size="l" color={color} />;
      break;
    }
  }
  return result;
};
